export interface Address {
    state?: string | null;
    suburb?: string | null;
    postcode?: string | null;
    street?: string | null;
    pricingZone?: string;
    latitude?: number;
    longitude?: number;
}
